<template>
    <div>
        <h3 class="text-center mb-8 mt-8 text-uppercase">Formulir Pelaporan Data</h3>
        <table class="table">
            <tr>
                <th scope="col" width="200">Unit</th>
                <td>{{ model.unit ? model.unit.name : '' }}</td>
            </tr>
            <tr v-if="model.unit_child">
                <th scope="col" width="200">Ruangan</th>
                <td>{{ model.unit_child.name }}</td>
            </tr>
            <tr>
                <th scope="col">Tahun</th>
                <td>{{ model.year }}</td>
            </tr>
            <tr>
                <th scope="col">Deskripsi</th>
                <td>{{ model.description }}</td>
            </tr>
        </table>

        <div class="card-body p-4 table-responsive">
            <table class="table table-bordered table-sm table-fixed">
                <thead class="text-uppercase text-center valign-middle">
                    <tr>
                        <th scope="col">No</th>
                        <th scope="col" class="width-200">Indikator</th>
                        <th scope="col" class="width-100">Target Indikator</th>
                        <th scope="col" colspan="2">Data yang dilaporkan</th>
                        <th scope="col" colspan="12">Rekapitulasi Data {{ model.unit ? model.unit.name : '' }} Per Bulan Tahun  {{ model.year }}</th>
                        <th scope="col" class="width-100">Jumlah</th>
                    </tr>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <!-- Data yang dilaporkan -->
                        <th scope="col"></th>
                        <th scope="col" class="width-200"></th>
                        <!-- Rekapitulasi -->
                        <th scope="col" class="width-100" :key="monthKey" v-for="(month, monthKey) in months">{{ month }}</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(item, key) in items">
                    <tr class="valign-middle" :key="`item-${key}`">
                        <td :rowspan="item.report_indicator_labels.length+1">{{ key+1 }}</td>
                        <td :rowspan="item.report_indicator_labels.length+1">{{ item.indicator ? item.indicator.name : '-' }}</td>
                        <td :rowspan="item.report_indicator_labels.length+1">{{ item.target_indicator_label }}</td>
                    </tr>
                    <tr class="valign-middle" :key="`detail-${key}-${detailKey}`" v-for="(detail, detailKey) in item.report_indicator_labels">
                        <!-- Data yang dilaporkan -->
                        <td class="text-center">{{ detailKey+1 }}</td>
                        <td>{{ detail.name }}</td>
                        <!-- Rekapitulasi -->
                        <td class="text-center" :key="`month-${key}-${detailKey}-${monthKey}`" v-for="(month, monthKey) in months">
                            {{ values[key][detailKey][monthKey] }}
                        </td>
                        <th scope="col" class="text-center">{{ calculateRecap(values[key][detailKey]) }}</th>
                    </tr>
                    <tr
                        v-if="item.result_label && item.result_formula"
                        class="valign-middle bg-secondary"
                        :key="`item-result-${key}`"
                    >
                        <td colspan="4"></td>
                        <th scope="col">Hasil ({{ item.result_label }})</th>
                        <th
                            scope="col"
                            class="text-center"
                             :key="`month-result-${key}-${monthKey}`"
                            v-for="(month, monthKey) in months"
                            v-html="resultLabels[key][monthKey]">
                        </th>
                        <th scope="col" class="text-center">{{ calculateResultLabels(key) }}</th>
                    </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'InputFormDataForm',
        props: {
            model: {
                type: Object,
                default: () => null
            },
            inputValues: {
                type: Array,
                default: () => []
            },
            items: {
                type: Array,
                default: () => []
            },
            months: {
                type: Array,
                default: () => []
            },
            monthLimit: Number,
        },
        data() {
            return {
                loading: false,
                values: [],
                resultLabels: [],
            }
        },
        created() {
            let resultLabels = []
            this.items.map((item, key) => {
                let values = []
                item.report_indicator_labels.map((detail, detailKey) => {
                    let details = []
                    this.months.map((month, monthKey) => {
                        const inputValue = this.inputValues.find((val) =>
                            val.indicator_id == item.indicator_id &&
                            val.report_indicator_id == detail.report_indicator_id &&
                            val.input_year == this.model.year &&
                            val.input_month == monthKey + 1)
                        details[monthKey] = inputValue ? inputValue.value : ''
                    })
                    values[detailKey] = details
                })
                this.values.push(values) // Per Month

                let percentagesMonths = []
                this.months.map((month, monthKey) => {
                    let formula = item.result_formula
                    values.map((value, i) => {
                        const alphabet = this.alphabet(i)
                        let val = value[monthKey] ? value[monthKey] : 0
                        formula = formula.replace(`[${alphabet}]`, val)
                    })
                    percentagesMonths[monthKey] = this.normalizeEval(formula)
                })
                resultLabels[key] = percentagesMonths
            })
            this.resultLabels = resultLabels // Hasil per Indikator
        },
        methods: {
            calculateResultLabels(key) {
                let total = []
                let result = 0
                let formula = this.items[key].result_formula
                this.values[key].map((detail, detailKey)  => {

                    if (!this.model.cumulative) {
                        total[detailKey] = 0
                        this.values[key][detailKey].map(val => {
                            if (val == null || val == undefined) {
                                return
                            }
                            total[detailKey] = val
                        })
                    } else {
                        total[detailKey] = this.sum(this.values[key][detailKey])
                    }

                    const alphabet = this.alphabet(detailKey)
                    formula = formula.replace(`[${alphabet}]`, total[detailKey])
                })
                result = this.normalizeEval(formula)
                return result
            },
            calculateRecap(values) {
                if (!this.model.cumulative) {
                    var result = 0
                    values.map(val => {
                        if (val == null || val == undefined) {
                            return result
                        }
                        result = val
                    })
                    return result
                }

                return this.sum(values)
            }
        }
    }
</script>
